import React from 'react'
// import { debugLog } from '../../../../util/logUtils';
import HybridLinkWidget from './HybridLinkWidget';


//use arrow function
function HybridLinkGroup(props = {}) {
	const wdata = props.data || {},
		data = wdata.data || {},
		cards = data.cards || wdata.cards || [],
		id= props.id || "hg";

	console.log("link group:", wdata);

	return (<div className='row'>
		{cards.map((card,index) => <HybridLinkWidget key={`hg-${id}-${index}`} data={card} />)}
	</div>)
}

export default HybridLinkGroup
